module.exports = __webpack_public_path__ + "static/media/Abeer.b36e96ad.jpg";